export const clearActiveStagingBuilder = (): StagingBuilderReducer => {
  return {
    type: "CLEAR_ACTIVE_STAGING_BUILDER",
    payload: null,
  };
};
